import React, { useContext } from 'react';
import {SessionContext} from './SessionContext'
import { NotificationContext } from '../notifications/NotificationContext'
import {Connection} from './Connection'

export function ConnectionProvider({ children }) {

    const notifications = useContext(NotificationContext)
    return (
      <SessionContext.Provider value={new Connection(notifications)}>
        {children}
      </SessionContext.Provider>
    )
  
  
  
  
  }
  
  
  export default ConnectionProvider;
